import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, computed } from "vue";
import CertificationResultCard from "@/components/v2/search-page-results/CertificationResultCard.vue";
import DisbursementResultCard from "@/components/v2/search-page-results/DisbursementResultCard.vue";
import { CertificationSearchResultModel } from "@/types/certifications";
import { DisbursementSearchResultModel } from "@/types/disbursements";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchPageSearchResult',
  props: {
  pageName: {
    type: String,
    default: "",
  },
  result: {
    type: Object as PropType<
      CertificationSearchResultModel | DisbursementSearchResultModel
    >,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const component = computed(() => {
  switch (props.pageName.toLowerCase()) {
    case "certifications":
      return CertificationResultCard;
    case "disbursements":
      return DisbursementResultCard;
    default:
      return undefined;
  }
});

const currentProperties = computed(() => {
  switch (component.value) {
    case CertificationResultCard:
      return { certification: props.result };

    case DisbursementResultCard:
      return { disbursement: props.result };
    default:
      return {};
  }
});

const currentListeners = computed(() => {
  return {};
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(component.value), _mergeProps(currentProperties.value, _toHandlers(currentListeners.value)), null, 16))
}
}

})